<template>
  <span
    v-if="option"
    class="location-category-icon"
    :class="'location-category-icon--' + option.tone"
    :style="{ width: `${props.size}px`, height: `${props.size}px`, flexBasis: `${props.size}px` }"
    :title="option.label"
    :aria-label="option.label"
    role="img"
  >
    <IconEmbedded :name="option.icon" :size="Math.round(props.size * 0.6)" color="currentColor" />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import { categoryOptionFor } from "@logic/LocationCategories";
import type { LocationCategoryOption } from "@logic/LocationCategories";
import type { LocationTagKind } from "@contracts/socialLocations";

const props = withDefaults(
  defineProps<{
    tagKind?: LocationTagKind | null;
    category?: string | null;
    /** Pass an option directly (ex. inside the type dropdown) instead of tagKind/category. */
    option?: LocationCategoryOption | null;
    size?: number;
  }>(),
  { tagKind: null, category: null, option: null, size: 30 }
);

const option = computed(() => props.option ?? categoryOptionFor(props.tagKind, props.category));
</script>

<style scoped>
.location-category-icon { display: inline-flex; align-items: center; justify-content: center; flex-grow: 0; flex-shrink: 0; border-radius: 50%; color: #45566b; background: #e9eef5; }
.location-category-icon--culture { color: #765099; background: #f1eafa; }
.location-category-icon--outdoors { color: #28745b; background: #e4f3e8; }
.location-category-icon--food { color: #a15a30; background: #fff0e2; }
.location-category-icon--shopping { color: #955571; background: #faeaf1; }
.location-category-icon--lodging { color: #4d678d; background: #eaf0fa; }
.location-category-icon--nightlife { color: #7251a0; background: #eee9fa; }
.location-category-icon--event { color: #68429a; background: #f0e9fa; }
</style>
